import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LANGUAGE_CONSTANTS } from 'src/app/shared/constants/language-constants';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import LoginRoutingPath from 'src/app/login/login-routing-path';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-completed',
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.scss'],
})
export class CompletedComponent {
  @Input() SuccessMessage!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  readonly LANG_CONST = LANGUAGE_CONSTANTS;
  CONSTANTS = CONSTANTS;

  constructor(
    private userService: UserLoginService,
    private router: Router,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService
  ) {
    this.localizationService.setupLocalization();
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
    if (this.SuccessMessage === CONSTANTS.PASSWORD_UPDATED || this.SuccessMessage === LANGUAGE_CONSTANTS.PHONE_UPDATED) {
      this.userService.logout().subscribe({
        next: (res: any) => {
          this.stateManagementService.updateLoggedIn(false);
          this.dialogRef?.close(false); // false for not stay login
          this.router.navigate([LoginRoutingPath.loginForm]);
        },
        error: (err: Error) => {},
      });
    }
  }
}
